export default __webpack_public_path__ + "71323cc.png";